import type { FaireProductEntity } from "../../entity_types/product";

export const p_ekr4m9ab9u: FaireProductEntity = {
  token: "p_ekr4m9ab9u",
  type: "product",
  name: "Effortless Embossed (YOUTH) Pullover - (Sky Blue/Yellow)",
  brandToken: "b_521sy8ez50",
  brandName: "Jadelynn Brooke",
  imageUrl:
    "https://cdn.faire.com/fastly/371912876a4a62b306e2e735e743dfe556bd9844343979c342e786408d126175.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/97aed7df975a0a98d7946a880cb9aae1b3d381a6fc726956d56fabfb74bdf1e3.jpeg",
    "https://cdn.faire.com/fastly/5c75a4c330247cb1a24c1f0fb24701eef496054ec2fa4d608b88903f073adb24.jpeg",
    "https://cdn.faire.com/fastly/4de20fa74a3d80b25062c2f1ed320e63eeb28722e968a6b14099a3c7c065c033.jpeg",
    "https://cdn.faire.com/fastly/db0a8581b7dda462a59a25e9298f80088634c5abd0f9a6f3fb350ae0b2c15f91.jpeg",
  ],
  priceDollars: 22,
  description:
    "***YOUTH PRODUCT*** the adult images are for reference of fit and close ups of fabric \n\nOur Effortless Embossed Pullovers are a fun, on-trend style that kids LOVE.  Comfy, durable, and easy to wear, they are perfect for school days, weekends, and everywhere in between that’s sure to become a fast favorite in your boutique.\n\nThe SOFTEST 60% cotton/40% polyester fabric with a comfy stretch\nAccent color ribbing on neckline, cuffs and hem at waist\nSide slits",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:16.042Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
